<template>
  <div :class="className(cellData)">
    <div class="yes-no">{{ toYesNoText(cellData) }}</div>
  </div>
</template>
<script>

export default {
  props: {
    cellData: {
      type: Boolean,
      default: () => {}
    }
  },
  methods: {
    className(value) {
      return value?"cell-yes":"cell-no";
    },
    toYesNoText(value) {
        debugger;
      return value?"NAI":"OXI";
    }
  }
};
</script>